
import { useCallback, useReducer } from 'react'
import moment from 'moment/moment'
import { v4 as uuidv4 } from 'uuid'

import { Model } from '../models/model'
import { getCalcTotalSumExpenses, getCalcTotalSumIncomes, getSuppliersItemsPpto, getTotalWithTaxes2 } from '../helpers/general'

const initialState = {
    projectionsList: [],
    detailProjections: {},
    cantidad: 0,
    mode_valorization: false,
    advance_percent: 30,
    total_proyectado: 0,
    suppliers_list: []
}

const REDUCER = (state = [], action) => {
    switch (action.type) {
        case 'update_detail':
            return {
                ...state,
                detailProjections: action.payload
            }

        case 'update_projections':
            return {
                ...state,
                projectionsList: action.payload
            }

        case 'update_cantidad':
            return {
                ...state,
                cantidad: action.payload
            }

        case 'update_adelanto':
            return {
                ...state,
                advance_percent: action.payload
            }

        case 'update_mode':
            return {
                ...state,
                mode_valorization: action.payload
            }

        case 'update_total_proyectado':
            return {
                ...state,
                total_proyectado: action.payload
            }

        case 'update_suppliers':
            return {
                ...state,
                suppliers_list: action.payload
            }


        default:
            return state
    }
}

export const useProjections = () => {

    const [state, dispatch] = useReducer(REDUCER, initialState)

    const { projectionsList, detailProjections, cantidad, advance_percent, mode_valorization, total_proyectado, suppliers_list } = state
    const { id_ppto, total_ppto, id_customer } = detailProjections

    const initLoadProjections = useCallback(async (initialList) => {
        const { projections, detail_ppto } = initialList

        const { items: titles } = detail_ppto
        const suppliers = await getSuppliersItemsPpto(titles)

        dispatch({
            type: 'update_suppliers',
            payload: suppliers
        })

        dispatch({
            type: 'update_detail',
            payload: initialList
        })

        dispatch({
            type: 'update_projections',
            payload: projections
        })

        const totalIncome = getCalcTotalSumIncomes(projections)

        dispatch({
            type: 'update_total_proyectado',
            payload: totalIncome
        })

    }, [])

    const initGetAllProjections = async (initialData) => {
        const filters = {
            id_contacto: initialData.id_customer,
            tipo_flujo: 'ingreso',
            id_ppto: initialData.id_ppto
        }

        const params = (new URLSearchParams(filters)).toString()
        const results = await Model.getAll({
            url: `reports/projections/all/?${params}`,
        })

        dispatch({
            type: 'update_projections',
            payload: results
        })

        const totalIncome = getCalcTotalSumIncomes(results)

        dispatch({
            type: 'update_total_proyectado',
            payload: totalIncome
        })

    }

    const initAddProjections = async (initialParams) => {

        const { items: titles } = initialParams.detail_ppto
        const suppliers = await getSuppliersItemsPpto(titles)
        dispatch({
            type: 'update_suppliers',
            payload: suppliers
        })

        let cantLoops = parseFloat(cantidad || 0)
        cantLoops = cantLoops === 0 ? 1 : cantLoops

        let saldoInicial = parseFloat(total_ppto)
        let cuota = (cantidad > 0 ? (saldoInicial / cantLoops) : 0)
        const total = cuota * (1.18)

        let corr = 0
        let listUpdate = projectionsList
        const initialMonth = moment(new Date()).format('YYYY-MM-DD')

        const getEgresos = async (suppliers, newIdIncome) => {
            let egresosList = []

            for (let p = 0; p < suppliers.length; p++) {
                egresosList = [
                    ...egresosList,
                    {
                        id: uuidv4(),
                        id_item: suppliers[p].id_item || null,
                        total_costo_item_ppto: suppliers[p].costo || null,
                        porcentaje_flow: 100,
                        referencia: 'Pago ' + corr + " - " + suppliers[p].nombre,
                        monto_neto: suppliers[p].costo,
                        id_doc: 1,
                        id_contacto: suppliers[p].id,
                        porcentaje_impuesto: 18,
                        total: suppliers[p].costo,
                        fecha_proyeccion: moment(initialMonth).add(p, 'months').format('YYYY-MM-DD'),
                        saved: false,
                        deleted: false,
                        id_proyeccion_ingreso: newIdIncome
                    }
                ]
            }

            return egresosList

        }

        for (let x = 0; x < cantLoops; x++) {
            corr = listUpdate.length + 1
            const newIdIncome = uuidv4()

            const newExpensesList = await getEgresos(suppliers, newIdIncome)
            const totalExpensesByIncome = getCalcTotalSumExpenses(newExpensesList)

            listUpdate = [
                ...listUpdate,
                {
                    id: newIdIncome,
                    porcentaje_flow: 0,
                    referencia: 'Facturación ' + corr,
                    id_item: 0,
                    monto_neto: cuota,
                    id_doc: 1,
                    total_item: 0,
                    porcentaje_impuesto: 18,
                    total: total,
                    fecha_proyeccion: moment(initialMonth).add(x, 'months').format('YYYY-MM-DD'),
                    saved: false,
                    deleted: false,
                    egresos_list: newExpensesList,
                    egresos_total: totalExpensesByIncome,
                }
            ]
        }

        const action = {
            type: 'update_projections',
            payload: listUpdate
        }

        dispatch(action)

    }

    const initAddProjectionsExpenses = async (initialParams, idIncome) => {

        const { items: titles } = initialParams.detail_ppto
        const suppliers = await getSuppliersItemsPpto(titles)
        dispatch({
            type: 'update_suppliers',
            payload: suppliers
        })

        // let cantLoops = parseFloat(cantidad || 0)
        // cantLoops = cantLoops === 0 ? 1 : cantLoops

        // let saldoInicial = parseFloat(total_ppto)
        // let cuota = (cantidad > 0 ? (saldoInicial / cantLoops) : 0)
        // const total = cuota * (1.18)

        let corr = 0

        const newExpenses = {
            id: uuidv4(),
            porcentaje_flow: 100,
            referencia: 'Pago ' + corr,
            monto_neto: 0,
            id_doc: 1,
            id_contacto: 0,
            porcentaje_impuesto: 18,
            total: 0,
            fecha_proyeccion: moment(new Date()).format('YYYY-MM-DD'),
            saved: false,
            deleted: false,
            id_proyeccion_ingreso: idIncome
        }

        const proyectionsListUpdate = projectionsList.map(it => {
            if (parseInt(it.id) === parseInt(idIncome)) {
                return {
                    ...it,
                    egresos_list: [
                        ...it.egresos_list,
                        newExpenses
                    ]
                }
            }
            return it
        })

        const action = {
            type: 'update_projections',
            payload: proyectionsListUpdate
        }

        dispatch(action)

    }

    const initAddProjectionsVal = async (initialParams) => {
        const cant = parseFloat(cantidad || 0)
        const totalPpto = parseFloat(total_ppto || 0)
        const initialMonth = moment(new Date()).format('YYYY-MM-DD')
        let listUpdate = projectionsList

        const percentMoneyAdvance = advance_percent
        const montoMoneyAdvance = (totalPpto * (percentMoneyAdvance / 100))

        listUpdate = [
            ...listUpdate,
            {
                id: uuidv4(),
                porcentaje_flow: percentMoneyAdvance,
                referencia: 'Adelanto',
                monto_neto: montoMoneyAdvance,
                id_doc: 1,
                id_item: 0,
                total_item: 0,
                porcentaje_impuesto: 18,
                total: montoMoneyAdvance,
                fecha_proyeccion: moment(initialMonth).add(0, 'months').format('YYYY-MM-DD'),
                saved: false,
                deleted: false
            }
        ]

        for (let x = 0; x < cant; x++) {
            const montoMoneyVal = totalPpto / cant
            const percentMoneyVal = montoMoneyVal / totalPpto * 100

            listUpdate = [
                ...listUpdate,
                {
                    id: uuidv4(),
                    porcentaje_flow: percentMoneyVal,
                    referencia: 'V' + (x + 1),
                    monto_neto: montoMoneyVal,
                    id_doc: 1,
                    id_item: 0,
                    total_item: 0,
                    porcentaje_impuesto: 18,
                    total: montoMoneyVal,
                    fecha_proyeccion: moment(initialMonth).add((x + 1), 'months').format('YYYY-MM-DD'),
                    saved: false,
                    deleted: false
                }
            ]
        }

        const action = {
            type: 'update_projections',
            payload: listUpdate
        }

        dispatch(action)

    }

    const initRemoveProjections = async (id) => {
        const foundSaved = projectionsList?.find(p => p.saved === true)

        let listUpdated = []
        if (foundSaved) {
            listUpdated = projectionsList?.map(it => {
                if (it.id === id) {
                    return {
                        ...it,
                        deleted: true
                    }
                }
                return it
            })
        } else {
            listUpdated = projectionsList?.filter(p => p.id !== id)
        }

        const totalIncome = getCalcTotalSumIncomes(listUpdated)

        dispatch({
            type: 'update_projections',
            payload: listUpdated
        })

        dispatch({
            type: 'update_total_proyectado',
            payload: totalIncome
        })

    }

    const initSaveProjections = async (setOpen) => {

        const dataForm = {
            id_contacto: id_customer,
            id_ppto: id_ppto,
            tipo_flujo: 'ingreso',
            projections: projectionsList
        }

        await Model.update({
            url: 'reports/projections/flow',
            dataForm
        })

        // setOpen(false)
    }

    const initChangeCantidad = async ({ target }) => {
        const newCantidad = parseInt(target.value)
        dispatch({
            type: 'update_cantidad',
            payload: newCantidad
        })
    }

    const initChangeMode = async ({ target }) => {
        const newChecked = target.checked
        dispatch({
            type: 'update_mode',
            payload: newChecked
        })
    }

    const initChangeAdelanto = async ({ target }) => {
        const newValue = parseInt(target.value)
        dispatch({
            type: 'update_adelanto',
            payload: newValue
        })
    }

    const initChangeRow = async (id, targetName, newValue) => {
        const listUpdated = projectionsList?.map(it => {
            if (parseInt(it.id) === parseInt(id)) {
                return {
                    ...it,
                    [targetName]: newValue
                }
            }
            return it
        })

        dispatch({
            type: 'update_projections',
            payload: listUpdated
        })

    }

    const initChangeRowItem = async (id, targetName, newValue, titles) => {
        const listUpdated = projectionsList?.map(it => {
            if (parseInt(it.id) === parseInt(id)) {

                const itemFound = titles.items.find(it => parseInt(it.id) === parseInt(newValue))
                const totalItem = itemFound?.precio_subtotal || 0

                return {
                    ...it,
                    [targetName]: newValue,
                    total_item: totalItem,
                    monto_neto: totalItem,
                    porcentaje_flow: 100,
                }
            }
            return it
        })

        dispatch({
            type: 'update_projections',
            payload: listUpdated
        })

    }

    const initChangeRowNumber = async (id, targetName, newValue, total_ppto) => {

        // let totalProyectado = 0
        const projectionsListUpdated = projectionsList?.map(it => {
            if (parseInt(it.id) === parseInt(id)) {
                const totalPpto = parseFloat(total_ppto)

                if (targetName === 'monto_neto') {
                    const montoNeto = newValue
                    //const totalItem = parseFloat(it.total_item)

                    let newPercent = 0
                    if (parseFloat(it.id_item) > 0) {
                        const totalItem = parseFloat(it.total_item)
                        newPercent = (montoNeto / (totalItem || 1)) * 100
                    } else {
                        newPercent = (montoNeto / (totalPpto || 1)) * 100
                    }

                    let totalExpenses = 0
                    const factor = newPercent / 100
                    const newExpensesList = it.egresos_list.map(ex => {
                        const supplier = suppliers_list?.find(s => parseInt(s.id) === parseInt(ex.id_contacto))
                        const totalGasto = (supplier?.costo || 0) * factor
                        const percent = (totalGasto / (supplier?.costo || 0)) * 100
                        const factorMasUno = (ex.porcentaje_impuesto / 100) + 1
                        const montoAPagar = totalGasto * factorMasUno
                        totalExpenses = totalExpenses + montoAPagar

                        return {
                            ...ex,
                            monto_neto: totalGasto,
                            porcentaje_flow: percent,
                            total: montoAPagar
                        }
                    })

                    return {
                        ...it,
                        monto_neto: montoNeto,
                        porcentaje_flow: newPercent,
                        egresos_list: newExpensesList,
                        egresos_total: totalExpenses
                    }

                }

                if (targetName === 'porcentaje_flow') {
                    const newPercent = newValue
                    const factor = (newPercent / 100)
                    let montoNeto = 0

                    if (parseFloat(it.id_item) > 0) {
                        const totalItem = parseFloat(it.total_item)
                        montoNeto = totalItem * factor
                    } else {
                        montoNeto = totalPpto * factor
                    }

                    let totalExpenses = 0
                    const newExpensesList = it.egresos_list.map(ex => {
                        const supplier = suppliers_list?.find(s => parseInt(s.id) === parseInt(ex.id_contacto))
                        const totalGasto = (supplier?.costo || 0) * factor
                        const percent = (totalGasto / (supplier?.costo || 0)) * 100
                        const factorMasUno = (ex.porcentaje_impuesto / 100) + 1
                        const montoAPagar = totalGasto * factorMasUno
                        totalExpenses = totalExpenses + montoAPagar
                        return {
                            ...ex,
                            porcentaje_flow: percent,
                            monto_neto: totalGasto,
                            total: montoAPagar
                        }
                    })

                    return {
                        ...it,
                        monto_neto: montoNeto,
                        porcentaje_flow: newPercent,
                        egresos_list: newExpensesList,
                        egresos_total: totalExpenses
                    }

                }

            }
            return it
        })

        const totalIncome = getCalcTotalSumIncomes(projectionsListUpdated)

        dispatch({
            type: 'update_projections',
            payload: projectionsListUpdated
        })

        dispatch({
            type: 'update_total_proyectado',
            payload: totalIncome
        })


    }

    // EXPENSES
    const initExpensesChangeRowNumber = async (params) => {
        const { current_item, target_name, new_value, proyections_list } = params
        const incomeId = current_item.id_proyeccion_ingreso

        const proyectionsListUpdated = proyections_list.map(it => {
            if (parseInt(it.id) === parseInt(incomeId)) {

                const expensesListUpdated = it.egresos_list.map(ite => {
                    if (parseInt(ite.id) === parseInt(current_item.id)) {
                        const supplier = suppliers_list?.find(s => parseInt(s.id) === parseInt(ite.id_contacto))

                        if (target_name === 'monto_neto') {
                            const totalGasto = new_value
                            const percent = (totalGasto / (supplier?.costo || 1)) * 100
                            const factorMasUno = (ite.porcentaje_impuesto / 100) + 1
                            const montoAPagar = totalGasto * factorMasUno
                            return {
                                ...ite,
                                monto_neto: totalGasto,
                                porcentaje_flow: percent,
                                total: montoAPagar
                            }
                        }

                        if (target_name === 'porcentaje_flow') {
                            const percent = new_value
                            const totalCosto = (supplier?.costo || 0)
                            const montoNeto = totalCosto * (percent / 100)
                            const factorMasUno = (ite.porcentaje_impuesto / 100) + 1
                            const montoAPagar = montoNeto * factorMasUno

                            return {
                                ...ite,
                                porcentaje_flow: percent,
                                monto_neto: montoNeto,
                                total: montoAPagar
                            }
                        }

                        return ite

                    }

                    return ite

                })

                const totalExpensesByIncome = getCalcTotalSumExpenses(expensesListUpdated)

                return {
                    ...it,
                    egresos_list: expensesListUpdated,
                    egresos_total: totalExpensesByIncome
                }
            }

            return it
        })

        dispatch({
            type: 'update_projections',
            payload: proyectionsListUpdated
        })

    }

    const initExpensesRemoveProjections = async (currentItem) => {
        const expenseId = currentItem.id
        const isSaved = currentItem.saved
        const incomeId = currentItem.id_proyeccion_ingreso

        const proyectionsListUpdated = projectionsList?.map(it => {
            if (it.id === incomeId) {
                let expensesListUpdated = []

                if (!isSaved) {
                    expensesListUpdated = it.egresos_list.filter(ex => ex.id !== expenseId)
                } else {
                    expensesListUpdated = it.egresos_list.map(ite => {
                        if (ite.id === expenseId) {
                            return {
                                ...ite,
                                deleted: true
                            }
                        }
                        return ite
                    })
                }

                // console.log('--after deleted!--', expensesListUpdated)
                const totalExpensesByIncome = getCalcTotalSumExpenses(expensesListUpdated)

                return {
                    ...it,
                    egresos_list: expensesListUpdated,
                    egresos_total: totalExpensesByIncome
                }

            }

            return it
        })

        dispatch({
            type: 'update_projections',
            payload: proyectionsListUpdated
        })

    }

    const initExpensesChangeRow = async (params) => {
        const { current_item, target_name, new_value, proyections_list, listaTiposDocumentos = [] } = params
        const incomeId = current_item.id_proyeccion_ingreso
        // console.log(target_name, new_value)

        const proyectionsListUpdated = proyections_list.map(it => {

            if (parseInt(it.id) === parseInt(incomeId)) {
                const expensesListUpdated = it.egresos_list.map(ite => {
                    if (parseInt(ite.id) === parseInt(current_item.id)) {
                        if (target_name === 'id_doc') {
                            const idDoc = new_value
                            const taxesFound = listaTiposDocumentos.find(t => parseInt(t.id) === parseInt(idDoc))

                            const newTotal = getTotalWithTaxes2({
                                amount: parseFloat(ite.monto_neto),
                                tax_percent: taxesFound.impuestos[0]?.porcentaje_impuesto,
                                type: taxesFound.impuestos[0]?.tipo_calculo
                            })

                            return {
                                ...ite,
                                id_doc: idDoc,
                                porcentaje_impuesto: taxesFound.impuestos[0]?.porcentaje_impuesto,
                                total: newTotal
                            }

                        } else {
                            return {
                                ...ite,
                                [target_name]: new_value
                            }
                        }
                    }
                    return ite
                })

                const totalExpensesByIncome = getCalcTotalSumExpenses(expensesListUpdated)

                return {
                    ...it,
                    egresos_list: expensesListUpdated,
                    egresos_total: totalExpensesByIncome
                }
            }
            return it
        })

        dispatch({
            type: 'update_projections',
            payload: proyectionsListUpdated
        })

    }

    const initExpensesChangeRowItem = async (params) => {
        const { current_item, new_value, proyections_list } = params
        const incomeId = current_item.id_proyeccion_ingreso
        // console.log(target_name, new_value, incomeId)

        const proyectionsListUpdated = proyections_list.map(it => {
            if (parseInt(it.id) === parseInt(incomeId)) {

                const expensesListUpdated = it.egresos_list.map(ite => {
                    if (parseInt(ite.id) === parseInt(current_item.id)) {

                        const idItem = new_value
                        const supplier = suppliers_list?.find(s => parseInt(s.id_item) === parseInt(idItem))
                        const totalCosto = (supplier?.costo || 0)
                        const percent = 100
                        const montoNeto = totalCosto
                        const factorMasUno = (ite.porcentaje_impuesto / 100) + 1
                        const montoAPagar = montoNeto * factorMasUno

                        return {
                            ...ite,
                            id_item: idItem,
                            id_contacto: supplier?.id,
                            referencia: 'Pago - ' + supplier?.descripcion,
                            total_costo_item_ppto: totalCosto,
                            porcentaje_flow: percent,
                            monto_neto: montoNeto,
                            total: montoAPagar
                        }

                    }

                    return ite
                })

                const totalExpensesByIncome = getCalcTotalSumExpenses(expensesListUpdated)

                return {
                    ...it,
                    egresos_list: expensesListUpdated,
                    egresos_total: totalExpensesByIncome
                }
            }

            return it
        })

        dispatch({
            type: 'update_projections',
            payload: proyectionsListUpdated
        })

    }

    return {
        initLoadProjections,
        initAddProjections,
        initAddProjectionsVal,
        initAddProjectionsExpenses,

        initChangeRow,
        initChangeRowItem,
        initChangeRowNumber,

        initExpensesChangeRowNumber,
        initExpensesRemoveProjections,
        initExpensesChangeRow,
        initExpensesChangeRowItem,

        initRemoveProjections,
        initSaveProjections,
        initChangeCantidad,
        initChangeMode,
        initChangeAdelanto,
        initGetAllProjections,

        suppliers_list,
        advance_percent,
        cantidad,
        mode_valorization,
        projectionsList,
        detailProjections,
        total_proyectado
    }

}